.stat-and-button-section {
    display: flex;
    align-items: center;
    gap: 12px;
}

.stat-and-button-section--no-action-menu {
    padding-right: 42px;
}
